import { Box, Divider } from '@mui/material';
import { PageTitle, IPageTitleProps } from './PageTitle';
import { PageTitleWithBack, IPageWithBackTitleProps } from './PageTitleWithBack';
import { FC } from 'react';

interface IPageTitleWithButton {
  button: JSX.Element;
  pageTitleProps?: IPageTitleProps;
  pageTitleBackProps?: IPageWithBackTitleProps;
  additionalHeaderContent?: JSX.Element;
  marginBottom?: string;
}

export const PageTitleWithButton: FC<IPageTitleWithButton> = ({
  button,
  pageTitleBackProps,
  pageTitleProps,
  additionalHeaderContent,
  marginBottom = '0.5rem'
}) => {
  return (
    <>
      <Box display="flex" marginBottom={marginBottom} flexWrap="wrap">
        <Box
          flex={{
            xs: 'none',
            sm: 1
          }}
          width={{
            xs: '100%',
            sm: 'auto'
          }}
        >
          {pageTitleBackProps?.backUrl ? (
            <PageTitleWithBack showDivider={false} {...pageTitleBackProps} />
          ) : (
            <PageTitle showDivider={false} {...pageTitleProps} />
          )}
        </Box>
        <Box
          width={{
            xs: '100%',
            sm: 'auto'
          }}
        >
          {button}
        </Box>
      </Box>
      {additionalHeaderContent && <Box>{additionalHeaderContent}</Box>}
      <Box marginBottom="1rem">
        <Divider />
      </Box>
    </>
  );
};
